import { useMutation } from "@tanstack/react-query";
import { getCMAApiClient } from "@cma/shared/apis/comps/cma/api-factories";
import { CMA_SCOPE_KEY } from "./cma.key";

type Props = {
  onSuccess?: () => void;
  onSettled?: () => void;
};

export type Params = {
  cmaId: string;
  mlsId: string;
  mlsSource: string;
  notes: string | null;
};

export const CMA_UPDATE_COMPARABLE_PROPERTY_MUTATION_KEY =
  "cma-update-comparable-property";

export const useUpdateComparableProperty = (props?: Props) => {
  const { onSuccess, onSettled } = props || {};
  const api = getCMAApiClient();
  const mutation = useMutation({
    mutationFn: async (params: Params) => {
      const { cmaId, mlsId, mlsSource, notes } = params;
      const response = await api.cMAControllerUpsertComparableProperty({
        id: cmaId,
        upsertComparablePropertyRequestDto: {
          mlsId,
          mlsSource,
          notes,
        },
      });

      return response;
    },
    onError: async (error) => {
      console.error(`Failed to update comparable property`, error);
    },
    onSettled: () => {
      onSettled?.();
    },
    onSuccess: () => {
      onSuccess?.();
    },
    mutationKey: [CMA_SCOPE_KEY, CMA_UPDATE_COMPARABLE_PROPERTY_MUTATION_KEY],
  });

  return mutation;
};
